import { Controller } from "@hotwired/stimulus"

// The show-hide controller is used to show or hide a specific element. This is done by firing the show or hide functions
// using stimulus actions. The target element to show or hide is specified with a query selector in the selector
// parameter, if none is specified the controller element is used.
// The hidden class is added or removed to manage visibility of the target element.
//
// The below would show the element with the id "my-element" on click.
// <div data-controller="show-hide" data-show-hide-selector="#my-element" data-action="click->show-hide#show">
// Note: The selector can be a comma separated list of selectors.
//
// The below would hide the element with the id "my-element" on click.
// <div data-controller="show-hide" data-show-hide-selector="#my-element" data-action="click->show-hide#hide">
// Note: The selector can be a comma separated list of selectors.
//
// The below would hide the element with the id "my-element" and show the element with the id "my-other-element" on click.
// <div data-controller="show-hide"
//      data-show-hide-hide-selector="#my-element"
//      data-show-hide-show-selector="#my-other-element"
//      data-action="click->show-hide#hideAndShow">
//
// You can also use this controller to conditionally show or hide an element based on the value of a form element:
// <div data-controller="show-hide">
//   <input type="text"
//          data-action="change->show-hide#showOrHide"
//          data-show-hide-selector-param="#element-to-show-or-hide"
//          data-show-hide-show-value-param="show">
//
//   <input type="text"
//          data-action="change->show-hide#showOrHide"
//          data-show-hide-show-selector-param="#element-to-show-on-match"
//          data-show-hide-hide-selector-param="#element-to-hide-on-match"
//          data-show-hide-show-value-param="show">
export default class extends Controller {
  show(event) {
    const selector = (event.params.showSelector || event.params.selector)

    if (selector) {
      selector.split(",").forEach((selector) => {
        this.element.querySelector(selector).classList.remove("d-none")
      })
    } else {
      this.element.classList.remove("d-none")
    }
  }

  hide(event) {
    const selector = (event.params.hideSelector || event.params.selector)
    if (selector) {
      selector.split(",").forEach((selector) => {
        this.element.querySelector(selector).classList.add("d-none")
      })
    } else {
      this.element.classList.add("d-none")
    }
  }

  showOrHide(event) {
    const show = event.params.toggleValue ? event.target.checked : (event.target && event.target.value == event.params.showValue)

    if (event.params.selector) {
      // When using the selector event parameter show on match and hide on mismatch
      show ? this.show(event) : this.hide(event)
    } else if (event.params.showSelector) {
      // When the showSelector event parameter is used show the showSelector and hide the hideSelector on match and
      // vise versa.
      if (show) {
        this.show({ params: { selector: event.params.showSelector } })

        if (event.params.hideSelector) {
          this.hide({ params: { selector: event.params.hideSelector } })
        }

        if(event.params.toggleValue) {
          event.target.dataset.showHideShowValue = "hide"
        }
      } else {
        this.hide({ params: { selector: event.params.showSelector } })

        if (event.params.hideSelector) {
          this.show({ params: { selector: event.params.hideSelector } })
        }

        if(event.params.toggleValue) {
          event.target.dataset.showHideShowValue = "show"
        }
      }
    } else {
      // When no selector is specified show or hide the controller element.
      show ? this.show() : this.hide()
    }
  }

  hideAndShow(event) {
    this.hide(event)
    this.show(event)
  }
}
